define('lib/gotomeetme/suggest-url',['require','api-access'],function (require) {
    var gotomeetApi = require('api-access').gotomeet;

    // clean strings to comply with valid characters for profile url
    function cleanString(str) {
        // replace any non valid character with a dash "-"
        return str.replace(/((?![\u00C0-\u1FFF\u2C00-\uD7FF\w0-9_-]).)/g, '-');
    }

    /**
     * Returns a promise that will resolve with a suggested G2MM URL.
     *
     * Example Jane Doe:
     * jane -> janedoe -> jdoe -> janed -> janedoe123
     *
     * The last option is the full name with a 1 to 3 digit number appended.
     *
     * Important to note that there is a small probability that the suggested URL is
     * already taken, given the final option assigns a random number.
     */
    return function (firstNameResponse, lastNameResponse) {
        var suggestionPromise = $.Deferred();
        var firstName = cleanString(firstNameResponse);
        var lastName = cleanString(lastNameResponse);
        var firstInitial = firstName.charAt(0);
        var lastInitial = lastName.charAt(0);

        // Since a request failure means the name is available, I've ordered the fail callback first.
        gotomeetApi.get(firstName)
            .fail(function () {
                suggestionPromise.resolve(firstName);
            })
            .done(function () {
                gotomeetApi.get(firstName + lastName)
                    .fail(function () {
                        suggestionPromise.resolve(firstName + lastName);
                    })
                    .done(function () {
                        gotomeetApi.get(firstInitial + lastName)
                            .fail(function () {
                                suggestionPromise.resolve(firstInitial + lastName);
                            })
                            .done(function () {
                                gotomeetApi.get(firstName + lastInitial)
                                    .fail(function () {
                                        suggestionPromise.resolve((firstName + lastInitial));
                                    })
                                    .done(function () {
                                        suggestionPromise.resolve(firstName + lastName +
                                            Math.floor((Math.random() * 1000) + 1));
                                    });
                            });
                    });
            });
        return suggestionPromise;
    };
});

